/**
 * @generated SignedSource<<3242a8b6dd0dca3ccd221c9fbe12cff4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MediaType = "cast" | "ins_highlight" | "ins_image" | "ins_live" | "ins_reel_story" | "ins_story" | "ins_video" | "other" | "tiktok" | "tiktok_go" | "twitter_image" | "twitter_video" | "youtube" | "youtube_short";
import { FragmentRefs } from "relay-runtime";
export type PostDraftInstagram$data = {
  readonly attachments: ReadonlyArray<{
    readonly contentType: string | null;
    readonly duration: number | null;
    readonly file: string;
    readonly id: string;
  }>;
  readonly campaign: {
    readonly avoidedSentence: string | null;
    readonly id: string;
    readonly mediaType: MediaType;
    readonly purpose: string | null;
    readonly socialNetwork: {
      readonly hashTag: string | null;
      readonly mentionTagContent: string | null;
      readonly productUrl: string | null;
    };
  };
  readonly content: string | null;
  readonly id: string;
  readonly influencerId: string | null;
  readonly script: string | null;
  readonly " $fragmentType": "PostDraftInstagram";
};
export type PostDraftInstagram$key = {
  readonly " $data"?: PostDraftInstagram$data;
  readonly " $fragmentSpreads": FragmentRefs<"PostDraftInstagram">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PostDraftInstagram",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "script",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "influencerId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Attachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "file",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "duration",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "contentType",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Campaign",
      "kind": "LinkedField",
      "name": "campaign",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "mediaType",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "purpose",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avoidedSentence",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "SocialNetwork",
          "kind": "LinkedField",
          "name": "socialNetwork",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "hashTag",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "productUrl",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "mentionTagContent",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Post",
  "abstractKey": null
};
})();

(node as any).hash = "d56f10fba59dea4be8e8f4324ccb677f";

export default node;
